import React, { useState } from 'react';
import {
  useSubscribeCapaNotificationSubscription,
  useFetchCapaNotificationQuery,
  useClearNewNotificationMutation,
  useReadNotificationMutation,
  CapaQuotationUserStatus,
  CapaNotificationsOutput,
  CapaErrorCode,
  FetchCapaNotificationQuery
} from '@generated/graphql';
import useClient from '@hooks/useClient';
import NotificationPresenter from './NotificationPresenter';
import { STORAGE_ACTION } from '@utils/storage';

const NotificationContainer: React.FC = () => {
  const { clientState } = useClient();
  const hasQuotationUserInfo =
    clientState.status === CapaQuotationUserStatus.Registered;
  const accessToken = localStorage.getItem(STORAGE_ACTION.CLIENT_ACCESS_TOKEN);
  const [notificationData, setNotificationData] = useState<
    FetchCapaNotificationQuery['fetchCAPANotification']
  >();
  useSubscribeCapaNotificationSubscription({
    skip:
      !clientState.id || !hasQuotationUserInfo || !accessToken ? true : false,
    fetchPolicy: 'network-only',
    onSubscriptionData: (incoming) => {
      const count =
        incoming.subscriptionData?.data?.subscribeCAPANotification?.data
          ?.count ?? 0;

      setNotificationData((prev) => {
        if (!prev) {
          return {
            result: CapaErrorCode.Success,
            data: {
              count,
              notifications: []
            }
          };
        } else {
          return {
            ...prev,
            data: {
              ...prev.data,
              notifications: prev.data?.notifications ?? [],
              count
            }
          };
        }
      });
    }
  });
  const { refetch } = useFetchCapaNotificationQuery({
    skip: !clientState.id,
    fetchPolicy: 'network-only',
    onCompleted: (result) => {
      if (result?.fetchCAPANotification?.result !== CapaErrorCode.Success)
        return;
      setNotificationData(result?.fetchCAPANotification);
    }
  });
  const [clearNewNotification] = useClearNewNotificationMutation();
  const [readNotification] = useReadNotificationMutation();

  const onReadNotification = (seq: number) => {
    readNotification({ variables: { seq: seq } });
  };

  const onReadAllNotification = () => {
    readNotification({ variables: { seq: -1 } });
  };

  const onClearNewNotification = () => {
    clearNewNotification().then(async (res) => {
      if (res.data?.clearNewNotification.result === CapaErrorCode.Success) {
        refetch();
      }
    });
  };

  return (
    <NotificationPresenter
      refetch={refetch}
      data={notificationData as CapaNotificationsOutput}
      onReadNotification={onReadNotification}
      onReadAllNotification={onReadAllNotification}
      onClearNewNotification={onClearNewNotification}
    />
  );
};

export default NotificationContainer;
